import globals from "@/styles/partials/global-variables";

export default {
  container: {
    borderTop: `1px solid ${globals.colors.gray5}`,
    paddingTop: "30px",
    "& .products-wrapper": {
      display: "flex",
      justifyContent: "center",
      flexFlow: "row wrap"
    }
  }
};
